import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import {
  getMyOffers,
  getOfferFavorites,
  getServicesFavorites,
} from "../../api";

import { cities_data, markets_data } from "../../data";

import { left_arrow } from "../../icons/left_arrow";

import Client from "../../utils/client";
import ShowModal from "../../components/show_modal";
import ContactModal from "../../components/contact_modal";

import React, { useState } from "react";

import { getStates } from "../../api";

import { circle_add } from "../../icons/circle_add";
import { exit_icon } from "../../icons/exit";

import { useAuth } from "../../store/authProvider";
import { EmptyStarIcon, FullStarIcon } from "../../icons/star";
import ConvertToArabicNumbers from "../../utils/convert_numbers";

import { buy_icon, sell_icon } from "../../icons/state";
import { delete_icon } from "../../icons/trash";
import empty_box from "../../images/empty_box.png";
import Skelton from "../../icons/skelton";

const Favorites = () => {
  const { isAuth } = useAuth();
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showServiceContactModal, setShowServiceContactModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [offer, setOffer] = useState();
  const getOffer = async (id) => {
    const response = await Client.get(`/offer/${id}`).then((res) => res.data);
    setOffer(response);
    setShowModal(true);
  };

  const { data: states } = useQuery({
    queryKey: ["states"],
    queryFn: () => getStates(),
    initialData: [],
  });

  const { data: offersFavorites, isFetching: offersFetching } = useQuery({
    queryKey: ["favorites"],
    queryFn: () => getOfferFavorites(),
    initialData: [],
  });

  const { data: servicesFavorites, isFetching: servicesFetching } = useQuery({
    queryKey: ["services"],
    queryFn: () => getServicesFavorites(),
    initialData: [],
  });

  const queryClient = useQueryClient();
  const addServiceFav = useMutation({
    mutationFn: (id) => {
      return Client.post(`/favorites/${id}`, {
        favorite_type: "service",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("services");
    },
  });

  const addOfferFav = useMutation({
    mutationFn: (id) => {
      return Client.post(`/favorites/${id}`, { favorite_type: "offer" });
    },
    onSuccess: () => {
      queryClient.invalidateQueries("favorites");
    },
  });
  const [service, setService] = useState();

  const getService = async (id) => {
    const response = await Client.get(`/services/single/${id}`).then(
      (res) => res.data
    );
    setService(response);
    setShowServiceModal(true);
  };

  if (offersFetching || servicesFetching) {
    return (
      <div dir="rtl" className="my-16 grid grid-cols-1 gap-4 px-0 lg:grid-cols-5 lg:mr-8">
        {[...Array(5).keys()].map((e, i) => (
          <Skelton key={i} />
        ))}
      </div>
    );
  }
  const addServiceFavorites = async (id) => {
    addServiceFav.mutateAsync(id);
  };
  const handleDelete = async (id) => {
    addOfferFav.mutateAsync(id);
  };

  return (
    <>
      {showServiceModal ? (
        <>
          <div className="fixed inset-0 z-[10000] flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div className="relative max-w-3xl w-[350px] mx-auto my-6">
              {/*content*/}
              <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-center justify-center p-5 rounded-t border-slate-200 ">
                  <div className="w-full flex items-center justify-between">
                    <div
                      className="text-red-600 w-8"
                      onClick={() => setShowServiceModal(false)}
                    >
                      {exit_icon}
                    </div>

                    <div
                      className="text-gray-500 w-8"
                      onClick={() => addServiceFavorites(service.id)}
                    >
                      {servicesFavorites.map((e) => e.id).includes(service.id)
                        ? FullStarIcon
                        : EmptyStarIcon}
                    </div>
                  </div>
                </div>
                {/*body*/}
                <div className="flex justify-center h-[126px] bg-center bg-no-repeat bg-flipped-logo ">
                  <img
                    src={service.service.image}
                    className=" h-[100px]  self-center "
                    alt=""
                  />
                </div>
                <div className="w-full flex justify-center items-center font-bold mt-4 text-lg">
                  {service.service.name}
                </div>
                <div className="relative font-bold flex-auto px-4 border-2 my-4 mx-4 rounded-lg">
                  <div className="flex flex-col gap-4 py-3" dir="rtl">
                    <ModalTable
                      description="الوصف : "
                      value={service.description}
                    />
                    <ModalTable
                      description="الموقع : "
                      value={service._state.name + " - " + service._city.name}
                    />

                    {service.price_per_day !== null && (
                      <ModalTable
                        description="نوع العمالة : "
                        value={service.price_per_day}
                      />
                    )}

                    {service.number_of_workers !== null && (
                      <ModalTable
                        description="عدد العمال : "
                        value={service.number_of_workers}
                      />
                    )}

                    {service.quantity !== null && (
                      <ModalTable
                        description="الكمية : "
                        value={service.quantity}
                      />
                    )}

                    {service.type !== null && (
                      <ModalTable description="النوع : " value={service.type} />
                    )}

                    {service.payload !== null && (
                      <ModalTable
                        description="الحمولة : "
                        value={service.payload}
                      />
                    )}

                    {service.line !== null && (
                      <ModalTable description="الخط : " value={service.line} />
                    )}

                    {service.temperature !== null && (
                      <ModalTable
                        description="درجة الحرارة : "
                        value={service.temperature}
                      />
                    )}
                    {service.height !== null && (
                      <ModalTable
                        description="الإرتفاع : "
                        value={service.height}
                      />
                    )}

                    {service.space !== null && (
                      <ModalTable
                        description="المساحة : "
                        value={service.space}
                      />
                    )}
                  </div>
                </div>
                {/*footer*/}
                <button
                  className="flex justify-center gap-2 items-center py-3 mb-4 mx-6 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear bg-primary rounded-xl shadow outline-none  hover:shadow-lg focus:outline-none"
                  type="button"
                  onClick={() => {
                    setShowServiceModal(false);
                    isAuth
                      ? setShowServiceContactModal(true)
                      : navigator("/login");
                  }}
                >
                  <div>طلب</div>
                  {circle_add}
                </button>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
        </>
      ) : null}
      {showServiceContactModal && (
        <ContactModal
          offer={service}
          setShowContactModal={setShowServiceContactModal}
        />
      )}

      {showContactModal && (
        <ContactModal offer={offer} setShowContactModal={setShowContactModal} />
      )}
      {showModal && (
        <ShowModal
          offer={offer}
          cities_data={cities_data}
          markets_data={markets_data}
          setShowContactModal={setShowContactModal}
          setShowModal={setShowModal}
          states={states}
          favoriteOffers={offersFavorites}
          type={"متوفر"}
        />
      )}
      <div className=" w-full px-5 lg:px-7 relative">
        {/* <div className="flex items-center flex-row-reverse justify-center  lg:justify-between"> */}
          <h1  className="text-end font-bold  text-[24px] my-10">
            المفضلة
          </h1>

          {/* <Link to="/home/profile">
            <button className="text-[#23AA49] text-xl pt-2 font-bold text-[24px] ">
              {left_arrow}
            </button>
          </Link> */}
        {/* </div> */}

        {offersFavorites?.filter((e) => e.status === "active").length === 0 &&
        servicesFavorites?.filter((e) => e.status === "active").length === 0 ? (
          <div className="flex flex-col col-span-2 mt-10 justify-center items-center text-center lg:col-span-5">
            <div>
              <img src={empty_box} alt=""></img>
            </div>
            <div className="font-bold mt-3">لا توجد محاصيل في المفضلة</div>
            <div className="h-10"></div>
          </div>
        ) : (
          <div className="flex flex-wrap gap-3 justify-end">
            {offersFavorites.map((item) => (
              <div
                className=" w-full lg:w-[13rem] lg:min-w-[13rem] "
                key={item.id}
              >
                <div
                  className="relative flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full bg-white border-2 border-primary rounded-2xl  h-[8rem] lg:w-auto lg:h-72 min-w-full lg:text-2xl"
                  key={item.id}
                  onClick={() => getOffer(item.id)}
                >
                  <img
                    src={item.subCategory.image}
                    className="  lg:h-2/4  max-w-[108px]  lg:max-w-full mt-2 "
                    alt=""
                  />
                  <div className="flex w-[160px] gap-2 lg:gap-1 lg:w-auto flex-col text-right  lg:mx-auto lg:font-normal">
                    <div
                      className="flex lg:justify-center items-center"
                      dir="rtl"
                    >
                      {/* {item.type === "buy" && <div className="px-2">مطلوب</div>}  */}
                      <div className="font-bold text-lg my-1">
                        {item.subCategory.name}
                      </div>
                    </div>
                    <div
                      className="lg:text-lg text-sm font-bold lg:font-normal mb-0.5 text-right lg:text-center"
                      dir="rtl"
                    >{`${ConvertToArabicNumbers(item.quantity)} ${
                      item._unit.name
                    }`}</div>
                    <div className=" mb-1 text-sm font-bold lg:font-normal lg:text-center">
                      {item._state.name}
                    </div>
                  </div>
                  <div className="flex lg:flex-row flex-row items-center justify-between gap-3  align-baseline">
                    <div className="flex items-center flex-row space-x-3 mb-2">
                      <div className=" hidden lg:block text-sm text-gray-400">
                        قبل{" "}
                        {Math.ceil(
                          (new Date().getTime() -
                            new Date(item.created_at).getTime()) /
                            86400000
                        )}{" "}
                        يوم
                      </div>
                      <div className="lg:absolute lg:inset-3 flex flex-col gap-6 lg:gap-52">
                        {item.offer_type === "buy" && (
                          <div className="flex flex-row-reverse items-center gap-2 text-sm font-bold text-primary">
                            {buy_icon}
                            <span>طلب</span>
                          </div>
                        )}

                        {item.offer_type === "sell" && (
                          <div className="flex flex-row-reverse items-center gap-2 text-sm font-bold text-primary">
                            {sell_icon}
                            <span>عرض</span>
                          </div>
                        )}
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(item.id);
                          }}
                          className="lg:ml-auto cursor-pointer"
                        >
                          {delete_icon}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {servicesFavorites?.map((item) => (
              <div
                className=" relative flex flex-row-reverse lg:flex-col items-center justify-evenly overflow-hidden w-full bg-white border-2 border-primary rounded-2xl  h-[8rem] lg:w-[13rem] lg:min-w-[13rem] lg:h-72 min-w-full lg:text-2xl"
                key={item.id}
                onClick={() => getService(item.id)}
              >
                <img
                  src={item?.service?.image}
                  className=" w-[80px] lg:h-[6rem] lg:w-auto   max-h-[80px]"
                  alt=""
                />
                <div
                  // className="text-right pr-6 lg:pr-0 w-[160px] lg:w-auto lg:text-center"
                  className="flex w-[160px] gap-2 lg:w-auto flex-col text-right  lg:mx-auto lg:font-normal pr-2 lg:p-0 lg:text-center"
                >
                  <div className="font-bold text-lg mb-2 lg:mb-4">
                    {item.service.name}
                  </div>
                  <div className="text-sm font-bold">{item._state.name}</div>
                </div>

                <div className="lg:absolute lg:inset-3 lg:gap-52 flex flex-col gap-6   mb-2  ">
                  {item.service_type === "demand" && (
                    <div className="flex flex-row-reverse items-center gap-2 text-sm font-bold text-primary">
                      {buy_icon}
                      <span>طلب</span>
                    </div>
                  )}
                  {item.service_type === "supply" && (
                    <div className="flex flex-row-reverse items-center gap-2 text-sm font-bold text-primary">
                      {sell_icon}
                      <span>عرض</span>
                    </div>
                  )}
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      addServiceFavorites(item.id);
                    }}
                    className="lg:ml-auto cursor-pointer"
                  >
                    {delete_icon}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default Favorites;
const ModalTable = ({ description, value }) => {
  return (
    <div className="flex gap-4">
      <div className="flex">
        <div className=" text-sm w-[80px] leading-relaxed font-bold">
          {description}
        </div>
        <div className="text-black font-bold">:</div>
      </div>

      <div className="text-sm leading-relaxed font-bold ">{value}</div>
    </div>
  );
};
